export const GTM_CONSENT_TYPES = {
  denied: 'denied',
  granted: 'granted',
};
